<template>
  <div class="headers">
    <div>
      <workfolder-icon></workfolder-icon>
      <div>workfolders</div>
    </div>
    <div>
      <videotrack-icon></videotrack-icon>
      <div>videotracks</div>
    </div>
    <div>
      <poi-icon></poi-icon>
      <div>pois</div>
    </div>
    <div>
      <track-icon></track-icon>
      <div>tracks</div>
    </div>
    <div>
      <route-icon></route-icon>
      <div>routes</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.headers {
  display: flex;
  flex: 0 0 auto;
  padding: 0 20px;

  & > div {
    flex: 1 1 auto;
    border: 1px solid #EFF2F7;
    padding: 5px;
    width: 20%;

    text-align: center;
    overflow: hidden;

    & + div {
      margin-left: 10px;
    }

    & > svg {
      max-width: 50px;
    }

    & > div {
      font-size: 0.8em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>

<script>
import WorkfolderIcon from '@/components/shared/icons/Workfolder'
import VideotrackIcon from '@/components/shared/icons/Videotrack'
import TrackIcon from '@/components/shared/icons/Track'
import RouteIcon from '@/components/shared/icons/Route'
import PoiIcon from '@/components/shared/icons/Poi'

export default {
  components: {
    WorkfolderIcon,
    VideotrackIcon,
    TrackIcon,
    RouteIcon,
    PoiIcon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/suggestions/Headers.vue